export const testimonials = [
  {
    id: 1,
    name: "Aravind S.",
    role: "Business Consultant",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop",
    text: "I was stuck at ₹80k/month for over a year. After installing the AI Content Engine and WhatsApp Automation from Pillar 2 & 3, I hit ₹3.5L in just 45 days. The clarity is unmatched.",
    rating: 5
  },
  {
    id: 2,
    name: "Priya M.",
    role: "Wellness Coach",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop",
    text: "The 'Done For You' workshops are a lifesaver. I'm not tech-savvy, but the step-by-step guidance on setting up my coaching funnel actually worked. My calendar is now booked 2 weeks in advance.",
    rating: 5
  },
  {
    id: 3,
    name: "Karthik R.",
    role: "Agency Owner",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop",
    text: "Most courses give you information. Diamond 2.0 gives you an OS. The AI Consulting Playbook helped me land my first ₹1.5L client using the exact scripts provided in the library.",
    rating: 5
  },
  {
    id: 4,
    name: "Suresh Kumar",
    role: "SME Owner",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop",
    text: "The ROI was clear within the first month. We automated our lead follow-up using the GHL modules and saw a 40% increase in show-up rates for our sales calls.",
    rating: 5
  },
  {
    id: 5,
    name: "Deepika V.",
    role: "Digital Marketer",
    image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop",
    text: "The YouTube Ads and Funnel systems are gold. I've spent lakhs on other programs, but the implementation plan here is what actually moved the needle for my career.",
    rating: 5
  },
  {
    id: 6,
    name: "Rajesh T.",
    role: "E-commerce Founder",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=150&h=150&fit=crop",
    text: "Finally, a system that understands the Indian market. The payment gateway and WhatsApp automation sections are specifically tailored for our audience. Highly recommended.",
    rating: 5
  }
];